define.alias("shared/helpers/format-currency", "settings/helpers/format-currency");